module.exports = __webpack_public_path__ + "static/media/in.640d85dd.svg";